import React from 'react';
import {
  FilterBox,
  FilterBoxTitle,
  FilterItemBox,
  FilterLineBox,
} from '../style';
import AllFilterInput from '../utils/ServedFilters/AllFilterInput';

// Порядок как в таблице: ФИО, Табельный, Департамент, Подразделение, Должность.
const fields = [
  { filld: 'meta_fio', title: 'ФИО' },
  { filld: 'meta_id_sotr', title: 'Табельный номер' },
  { filld: 'meta_departament', title: 'Департамент' },
  { filld: 'meta_podrazdelenie', title: 'Подразделение' },
  { filld: 'meta_doljnost', title: 'Должность' },
];

function MetaParamsFilters({ changeFilter }) {
  return (
    <FilterBox>
      <FilterBoxTitle>Поиск по сотруднику</FilterBoxTitle>
      <FilterItemBox>
        {fields.map((f) => (
          <FilterLineBox key={f.filld}>
            <AllFilterInput
              changeFilter={changeFilter}
              filld={f.filld}
              title={f.title}
              smallTitle="true"
              like="true"
            />
          </FilterLineBox>
        ))}
      </FilterItemBox>
    </FilterBox>
  );
}
export default MetaParamsFilters;
